import { useDatepickerContext } from 'hooks/useDatepickerContext';
import { useState } from 'react';
import type { MonthsProps } from 'react-day-picker';
import { useDayPicker } from 'react-day-picker';

import { MonthPicker } from './MonthPicker';
import { TimePicker } from './TimePicker';
import { YearPicker } from './YearPicker';

/**
 * The Container of Calendar Popover component.
 */
export const Container = (daysToPickContainer: MonthsProps) => {
  const { classNames, styles } = useDayPicker();

  const { changingMonth, changingYear, selection } = useDatepickerContext();
  const { mode } = selection;
  const justTime = mode === 'time';
  const includeTimePicker = mode === 'single-time' || mode === 'time';
  // Taken here because this mounts with the popover and, unlike the time
  // picker, stays mounted while the month and year grids are shown.
  const [valueAtOpen] = useState(
    selection.mode === 'range' ? undefined : selection.value,
  );

  return (
    <div className={classNames.months} style={styles.months}>
      {/* Day Picker */}
      {!justTime && daysToPickContainer.children}
      {/* Month Picker */}
      {changingMonth && <MonthPicker />}
      {/* Year Picker */}
      {changingYear && <YearPicker />}
      {/* Time Picker */}
      {includeTimePicker && !(changingMonth || changingYear) && (
        <TimePicker valueAtOpen={valueAtOpen} />
      )}
    </div>
  );
};
